import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import styles from "../../assets/css/modules/claims/how-to-claim.css";
import Contentify from "../../content/Contentify";
import { connect } from "react-redux";
import Store from "../../content/Store";
import Article from "../shared/Article";
import MakeAClaimButton from "../shared/buttons/MakeAClaimButton";
import PromoContainer from "../shared/containers/PromoContainer";
import NumberStepList from "../shared/groups/NumberStepList";
import HelpSection from "../shared/HelpSection";
// import PromoImageCard from "../shared/PromoImageCard";
import  MskSection  from "../shared/MskSection";
import { Paths, Urls } from "../../constants/UrlConstants";
import { EPDomain_ROOT } from "../../constants/EP-config";
import EPQueryParams from "../../constants/EPQueryParams";
import ShadowedContainer from "./../shared/containers/ShadowedContainer";
import {
  TravelEU,
  TravelWorld,
  Treatment,
  Diagnostics,
  StandardOP,
  FullOP,
  EnhancedOP,
  MentalHealth,
  Therapies,
  ExtendedCover
} from "../../constants/SMEModules";
import { shouldShowIfAnySMEModulesMatch } from "./../../helpers/SMEModules/smeModuleHelper";
import PromoImageCard from "./../../components/shared/PromoImageCard";
import { getLayout } from "../../layout/Layout";
import { Layouts } from "../../constants/Constants";
import DateHelper from "../../helpers/DateHelper";
import MemberHelper from "../../helpers/MemberHelper";

export const mapStateToHowToClaim = (state) => {
  const selectedPolicy = state.policyReducer && state.policyReducer.selectedPolicy;
  const loggedInMember = MemberHelper.getCurrentLoggedInMemberFromPolicy(
    selectedPolicy
  );
  const isAgeAbove18 = DateHelper.isAgeAbove18(loggedInMember.DateOfBirth);

  return {
    IsSMEModular: selectedPolicy && selectedPolicy.IsSMEModular,
    isLapsed: selectedPolicy && selectedPolicy.IsLapsed,
    ShouldShowTravelSMEContent: shouldShowIfAnySMEModulesMatch(selectedPolicy, [
      TravelEU,
      TravelWorld
    ]),
    featureFlagEP: state.unreadMessagesReducer.featureFlagEP,
    isAgeAbove18,
    IsInternalView: state.policyReducer && state.policyReducer.policyDetails 
    && state.policyReducer.policyDetails.IsInternalView,
    ShouldShowPMISMEContent: shouldShowIfAnySMEModulesMatch(selectedPolicy, [
      Treatment,
      Diagnostics,
      StandardOP,
      FullOP,
      EnhancedOP,
      MentalHealth,
      Therapies,
      ExtendedCover
    ])
  };
};
export class HowToClaim extends Component {
  static content = Store.HowToClaim;

  constructor(props) {
    super(props);
    this.state = {
      Authurl:Urls.EngagementPortal[EPDomain_ROOT].preauth,
      ClaimBackUrl : Urls.EngagementPortal[EPDomain_ROOT].claimBackPayment,
    };
  }

  handleAuthCallback = (childData) => {
    this.setState({ Authurl: childData });
  };

  handleClaimCallback = (childData) => {
    this.setState({ ClaimBackUrl: childData });
  };
  
  render() {
    return (
      <Fragment>
        <ShadowedContainer>
          <div className={"row " + styles.howToClaim}>
            {this.props.ShouldShowPMISMEContent || !this.props.IsSMEModular ? (
              <div id="pmiClaimsContent">
                <div className="col-lg-12">
                  <Article
                    header={this.props.content.heading}
                    body={this.props.content.description}
                  />
                </div>
                <div className="col-12">
                  <h3 id="claimProcessHeader">
                    {this.props.content.claimProcessHeader}
                  </h3>
                </div>
                <div className="col-lg-12">
                  <NumberStepList>
                    {this.props.content.checkYourCoverDetail}
                    {this.props.content.tellUsAboutYourClaimDetail}
                    {this.props.content.weWillGetBackToYouDetail}
                    {this.props.content.paymentForTheTreatmentDetail}
                  </NumberStepList>
                </div>
                <div
                  className={"col-lg-9 text-right " + styles.buttonContainer}
                >
                  <MakeAClaimButton />
                </div>
              </div>
            ) : null}
            <EPQueryParams url={this.state.Authurl} updatedURL={this.handleAuthCallback}/>
            <EPQueryParams url={this.state.ClaimBackUrl} updatedURL={this.handleClaimCallback}/> 
            {this.props.ShouldShowTravelSMEContent ? (
              <div id="travelClaimsContent">
                <div className={"col-lg-12 " + styles.travelBlock}>
                  <Article
                    header={this.props.content.travelHeading}
                    body={this.props.content.travelDescription}
                  />
                </div>
                <div className="col-12">
                  <h3 id="travelClaimProcessHeader">
                    {this.props.content.travelClaimProcessHeader}
                  </h3>
                </div>
                <div className="col-lg-12">
                  <NumberStepList>
                    {this.props.content.RequestTravelClaimForm}
                    {this.props.content.CompleteTravelClaimForm}
                    {this.props.content.SubmitTravelClaimForm}
                  </NumberStepList>
                </div>{" "}
              </div>
            ) : null}
          </div>

          {this.props.ShouldShowPMISMEContent || !this.props.IsSMEModular ? (
            <HelpSection
              HelpSet={
                this.props.featureFlagEP === false || this.props.featureFlagEP === undefined ?
                this.props.content.helpSet :
                this.props.content.helpSetEP(this.state.Authurl, this.state.ClaimBackUrl, this.props.IsInternalView)}
              HeadingLinkTo={this.props.content.headingLinkTo}
              HeadingLinkText={this.props.content.headingLinkText}
              MoreHelpLinkTo={this.props.content.moreHelpLinkTo}
              MoreHelpLinkText={this.props.content.moreHelpLinkText}
            />
          ) : null}
        </ShadowedContainer>
        <PromoContainer>
          {/* <PromoImageCard
            LinkTo={this.props.content.AskMedExpert.LinkTo}
            ImgSrc={this.props.content.AskMedExpert.IconSrc}
            ImgSrcMobile={this.props.content.AskMedExpert.IconSrcMobile}
            Heading={this.props.content.AskMedExpert.Heading}
            Description={this.props.content.AskMedExpert.Description}
            LinkText={this.props.content.AskMedExpert.LinkText}
            LeftImage
          /> */}
          {!this.props.isLapsed && (this.props.isAgeAbove18 ? <MskSection accessPage={Paths.HowToClaim} UniqueKey="mskBanner" />:
          (
            <PromoImageCard
            ImgSrc={Store.PromoCards.AccessHealthSupportSrc.IconSrc}
            ImgSrcMobile={
              Store.PromoCards.AccessHealthSupportSrc.IconSrcMobile
            }
            Heading={Store.PromoCards.AccessHealthSupportSrc.Heading}
            Description={
              Store.PromoCards.AccessHealthSupportSrc.Description
            }
            LinkText={Store.PromoCards.AccessHealthSupportSrc.LinkText}
            LinkTo={getLayout()===Layouts.HOL ?  Store.PromoCards.AccessHealthSupportSrc.LinkToHOL : Store.PromoCards.AccessHealthSupportSrc.LinkTo}
            LeftImage
          />
          ))}
        </PromoContainer>
      </Fragment>
    );
  }
}

export default withRouter(
  connect(mapStateToHowToClaim)(Contentify(HowToClaim))
);
